import React from 'react';
import { cn } from '../lib/utils';
interface NavItem {
  id: string;
  label: string;
}
interface FloatingNavProps {
  items: NavItem[];
  activeId: string;
  className?: string;
}
export function FloatingNav({
  items,
  activeId,
  className
}: FloatingNavProps) {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className={cn('fixed right-6 md:right-12 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-4 mix-blend-difference', className)} aria-label="Section navigation" data-id="element-37">
      {items.map(item => {
      const isActive = activeId === item.id;
      return <button key={item.id} onClick={() => scrollTo(item.id)} className="group flex items-center justify-end gap-4" aria-label={`Scroll to ${item.label}`} aria-current={isActive ? 'true' : 'false'} data-id="element-38">
            <span className={cn('text-xs font-mono tracking-widest uppercase transition-all duration-500 opacity-0 group-hover:opacity-100 translate-x-4 group-hover:translate-x-0', isActive ? 'text-coral opacity-100 translate-x-0' : 'text-muted-foreground')} data-id="element-39">
              {item.label}
            </span>
            <div className={cn('w-1.5 h-1.5 rounded-full transition-all duration-500', isActive ? 'bg-coral scale-150 coral-glow' : 'bg-muted-foreground/30 group-hover:bg-muted-foreground')} data-id="element-40" />
          </button>;
    })}
    </nav>;
}